import { PhoneTypes } from 'generated/graphql-types';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { ExtensionHackedFraudDetails } from '../../extension-details/helpers/hacked-fraud-helper';
import {
   BaseStationItem,
   DeviceItem,
   PhoneRegisterListItem,
   SipUserItem,
} from '../models/phone-register-results.model';
import { GetPhones_phonesConnection_items } from '../queries/generated/GetPhones';

export const phoneRegisterColumns: string[] = ['phoneType', 'name', 'actions'];

export function getPhoneDisplayName(phone: GetPhones_phonesConnection_items): string {
   switch (phone.phoneType) {
      case PhoneTypes.Softphone:
         return phone.sipUsersConnection.items[0]?.userName ?? '';
      case PhoneTypes.Hardphone:
         return (
            phone.devicesConnection.items?.map((item) => {
               return `${addSpacesToTypeName(item.deviceTypeId ?? 'unknown')} - ${item.macAddress}`;
            })[0] ?? ''
         );
      case PhoneTypes.Appsuite:
         return 'AppSuite';
      case PhoneTypes.Handset:
         return phone.handsetIpei || '';
      default:
         return '';
   }
}

export function convertPhoneRegisterListItem(
   getPhoneItem: GetPhones_phonesConnection_items,
   hackedFraudDetails: ExtensionHackedFraudDetails | null
): PhoneRegisterListItem {
   let hasIssue = false;

   if (hackedFraudDetails && Array.isArray(hackedFraudDetails.hackedPhones)) {
      hasIssue = hackedFraudDetails.hackedPhones.some((detail) => detail.phoneId === getPhoneItem.phoneId);
   }

   return {
      domain: getPhoneItem.extension?.account?.domain || null,
      createDate: getPhoneItem.createDate,
      createUserName: getPhoneItem.createUser?.name || null,
      phoneId: getPhoneItem.phoneId,
      phoneType: getPhoneItem.phoneType,
      handsetIpei: getPhoneItem.handsetIpei,
      name: getPhoneDisplayName(getPhoneItem),
      baseStationHandsets: getPhoneItem.baseStationHandsetsConnection.items.map(
         (baseStationHandset): BaseStationItem => {
            return {
               baseStationHandsetId: baseStationHandset.baseStationHandsetId,
               deviceId: baseStationHandset.device.deviceId,
               device: {
                  deviceId: baseStationHandset.device.deviceId,
                  phoneId: baseStationHandset.phoneId,
                  macAddress: baseStationHandset.device.macAddress,
                  description: baseStationHandset.device.description,
                  deviceTypeId: baseStationHandset.device.deviceTypeId,
                  fields: [],
               },
               phoneId: baseStationHandset.phoneId,
               sortId: baseStationHandset.sortId,
            };
         }
      ),
      sipUsers: getPhoneItem.sipUsersConnection.items.map((sipUser): SipUserItem => {
         return {
            hashPassword: sipUser.hashPassword,
            sipUserId: sipUser.sipUserId,
            userName: sipUser.userName,
            accountId: sipUser.accountId,
            isConnected: sipUser.isConnected,
            userAgents: sipUser.userAgents,
            internalIps: sipUser.internalIps,
            externalIps: sipUser.externalIps,
         };
      }),
      devices: getPhoneItem.devicesConnection.items.map((device): DeviceItem => {
         return {
            deviceId: device.deviceId,
            macAddress: device.macAddress,
            deviceTypeId: device.deviceTypeId,
            displayName: getPhoneDisplayName(getPhoneItem),
            accountId: device.accountId,
            phoneId: device.phoneId,
            ztStatus: device.ztStatus,
         };
      }),
      numberOfLineKeys: getPhoneItem.numberOfLineKeys,
      updateDate: getPhoneItem.updateDate,
      updateUserName: getPhoneItem.updateUser?.name || null,
      hasIssue: hasIssue,
      adminPassword: getPhoneItem.adminPassword,
   };
}
